export default "/images/cda53a56794465272ed3ece260e18d87.avif";